<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage">
      <div class="text-center" style="color: black; background: #ddd;">
        <h1>{{ msg }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import backgroundImage1 from '../../../../assets/1.png';
import backgroundImage2 from '../../../../assets/2.png';
import backgroundImage3 from '../../../../assets/3.png';
import backgroundImage4 from '../../../../assets/4.png';
import backgroundImage5 from '../../../../assets/5.png';
import backgroundImage6 from '../../../../assets/6.png';
import backgroundImage7 from '../../../../assets/7.png';

// const INDECX_URL = 'https://app-indecx.com.br'; // Production
// const INDECX_URL = 'https://indecx.pe'; // Staging

export default {
  data: () => ({
    msg: '',
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
  }),

  async created() {
    this.msg = `${this.$t('ssoPage.auth')}...`;
    const imgs = [
      backgroundImage1,
      backgroundImage2,
      backgroundImage3,
      backgroundImage4,
      backgroundImage5,
      backgroundImage6,
      backgroundImage7,
    ];
    this.bgPage.background = `url('${imgs[Math.floor(Math.random() * 7)]}')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';

    const userId = this.$route.params.userId;
    const tokenId = this.$route.params.tokenId;
    try {
      const resp = await axios.post(
        `${process.env.API_ROOT}/sso`,
        { userId, tokenId },
        { headers: { 'Access-Control-Allow-Origin': '*' } },
      );
      localStorage.setItem('_indecx', JSON.stringify(resp.data));
      this.$router.push(`/dashboard/${resp.data.companyId}`);
    } catch (error) {
      this.msg = `${this.$t('ssoPage.noAuth')}: ${error.response.data.message}`;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/home/sso/index.vue